exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img {\n  max-height: 310px;\n  height: auto;\n  width: 100%;\n  float: left;\n  padding: 20px;\n  -webkit-transition: .5s ease;\n  transition: .5s ease;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n\n}\n\nh2 {\n  font-size: 20px;\n  font-family:serif;\n  text-align: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n\n.shopping:hover #athlete {\n  opacity: 0.3;\n}\n\n.shopping:hover #box {\n  opacity: 0.3;\n}\n\n.shopping:hover #pride {\n  opacity: 0.3;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/athlete/athlete.component.css
// module id = ../../../../../src/app/athlete/athlete.component.css
// module chunks = main